import { Alert, AlertTitle } from "@mui/material"

import { useWebAdminTranslations } from "@/hooks"

const PriceAlert = () => {
  const { t } = useWebAdminTranslations()
  return (
    <Alert severity="info">
      <AlertTitle>{t("[SKIPASS_PRICELIST_PRICEALERT_HEADING]")}</AlertTitle>
      {t("[SKIPASS_PRICELIST_PRICEALERT_BODY]")}
      <div>{t("[SKIPASS_PRICELIST_PRICEALERT_BODY_2]")}</div>
    </Alert>
  )
}

export default PriceAlert
